var render = function render(){var _vm=this,_c=_vm._self._c;return (this.selectedProduct)?_c('div',[_c('product-form',{attrs:{"product":this.selectedProduct,"action":"put"},on:{"update-price":(value) => { _vm.selectedProduct.price = value}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }